// IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: живой поиск и чипсы поиска): чистая логика поиска панелей-меню (MenuPanel) — чипс поиска того же вида,
// что над таблицей, и «Show rows without matches» по умолчанию.
// Заказ дословно: «в форме меню … при внесении строки поиска, как и сейчас, сразу делать поиск. При нажатии Enter создавать чипс поиска. Только такой же
// чипс поиска, как и над таблицей мы делаем. И при этом и в первом, и во втором случае по умолчанию в чипсе поиска включаю опцию показать значение без збігів».
//  - чипс панели — объект чипса таблицы { segment: 'CHIP-Search', title, meta: { use, pi, titleHTML }, showAllLines } (рисует AttrChips, mode 'Legacy');
//    при выключателе fe.ux.menuSearchChipForm = false — прежняя строка (menuChip_text понимает оба вида);
//  - у каждого запроса (чипс / набираемый текст) свой флажок keep: чипс — свой «Show rows without matches», текст — переключатель ряда панели;
//    пункт прячется, если не прошёл запрос со снятым флажком; не прошёл только запросы с флажком — остаётся на месте приглушённым;
//  - переключатель ряда без выбора пользователя — включён (fe.ux.menuSearchShowAllDefault, дефолт вкл.); явный выбор '0' / '1' уважается.

const escHtml = (s) => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')

// текст чипса: объект (форма чипса таблицы) либо строка (прежний вид)
export function menuChip_text(c) {
    if (c && typeof c === 'object') return String(c.title || '')
    return String(c || '')
}

// новый чипс поиска панели — тот же объект, что AttrChips.addChip кладёт в полосу таблицы; подпись — экранированный текст (AttrChips выводит её v-html)
export function menuChip_new(title, showAll) {
    const s = String(title || '').trim()
    return { segment: 'CHIP-Search', title: s, meta: { use: true, pi: 'pi-search', titleHTML: escHtml(s) }, showAllLines: !!showAll }
}

// чипс в любом виде → объект; у строки (чипс прежнего вида после включения выключателя) флажок — умолчание панели
export function menuChip_obj(c, showAllDefault) {
    if (c && typeof c === 'object') return menuChip_new(c.title, c.showAllLines === true)
    return menuChip_new(c, showAllDefault)
}

// список, который вернула полоса AttrChips (update:modelValue после ⊗, флажка, правки текста двойным щелчком) → чипсы панели;
// снятые (meta.use === false) и пустые выпадают, служебные поля полосы (_index, matchCount, isEditing …) не переносятся
export function menuChips_fromModel(list) {
    const out = []
    for (const c of (Array.isArray(list) ? list : [])) {
        if (!c || typeof c !== 'object' || (c.meta && c.meta.use === false)) continue
        const t = String(c.title || '').trim()
        if (t) out.push(menuChip_new(t, c.showAllLines === true))
    }
    return out
}

// запросы поиска с флажками: чипсы, затем набираемый текст; повтор текста (без учёта регистра) сливается в один запрос — флажок «И» (снятый у любого
// из повторов прячет). chipForm = false — флажок чипсов, как раньше, общий (liveKeep)
export function menuQuery_items(chips, q, liveKeep, chipForm) {
    const src = []
    for (const c of (Array.isArray(chips) ? chips : [])) src.push({ text: menuChip_text(c).trim(), keep: (chipForm && c && typeof c === 'object') ? c.showAllLines === true : !!liveKeep })
    src.push({ text: String(q || '').trim(), keep: !!liveKeep })
    const out = [], at = new Map()
    for (const x of src) {
        if (!x.text) continue
        const k = x.text.toLowerCase()
        if (at.has(k)) { const o = out[at.get(k)]; o.keep = o.keep && x.keep; continue }
        at.set(k, out.length)
        out.push({ text: x.text, keep: x.keep })
    }
    return out
}

// третий аргумент MenuPanel._shownFilter: boolean, когда флажки всех запросов одинаковы (прежний путь кода), иначе массив флажков по запросам
export function menuShowAll_arg(keeps, fallback) {
    if (!Array.isArray(keeps) || !keeps.length) return !!fallback
    if (keeps.every(Boolean)) return true
    if (!keeps.some(Boolean)) return false
    return keeps.slice()
}

// начальное состояние переключателя ряда: сохранённый выбор пользователя ('1' / '0') главнее; нет выбора — умолчание (fe.ux.menuSearchShowAllDefault)
export function menuShowAll_initial(stored, defaultOn) {
    if (stored === '1') return true
    if (stored === '0') return false
    return defaultOn !== false
}

// IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: живой поиск и чипсы поиска): ⊗ у чипса полосы в режиме Legacy — список для update:modelValue без снятого чипса.
// modelValue хоста MenuPanel — свежий массив computed chipModel, Vue его не наблюдает: splice в AttrChips.removeChip не пересчитывал computed chips, полоса
// отдавала прежний список (со снятым чипсом), и MenuPanel.onChipsModel строил тот же чипс заново (⊗ «не снимал»). Снятый убирается явно, по ссылке;
// у наблюдаемого modelValue (Search.vue) chips уже пересчитан — снятого в нём нет, список не меняется
export function chipsLegacy_afterRemove(chips, removed) {
    return (Array.isArray(chips) ? chips : []).filter(c => c !== removed)
}
